import {
	bulkMarkSteamPosted,
	bulkUpdateSteamStatus,
	getReviewDistributionCounts,
	getReviewDistributions,
	retryOpenCritic,
	updateMetacriticStatus,
	updateSteamStatus,
} from '@/services/community/contents/review-distributions'

export default {
	namespaced: true,
	state: {
		list: {
			data: [],
			meta: { total: 0 },
		},
		status: 'init',
		counts: {
			total: 0,
			steam_pending: 0,
			steam_drafted: 0,
			opencritic_pending: 0,
			opencritic_failed: 0,
			metacritic_pending: 0,
		},
		countsStatus: 'init',
	},
	getters: {
		getList(state) {
			return state.list
		},
		getStatus(state) {
			return state.status
		},
		getCounts(state) {
			return state.counts
		},
		getCountsStatus(state) {
			return state.countsStatus
		},
	},
	mutations: {
		SET_LIST(state, value) {
			state.list = value
		},
		SET_STATUS(state, value) {
			state.status = value
		},
		SET_COUNTS(state, value) {
			state.counts = value
		},
		SET_COUNTS_STATUS(state, value) {
			state.countsStatus = value
		},
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_STATUS', 'pending')
			try {
				const { data } = await getReviewDistributions(params)
				commit('SET_LIST', data)
				commit('SET_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATUS', 'init')
				throw error
			}
		},
		async fetchCounts({ commit }) {
			commit('SET_COUNTS_STATUS', 'pending')
			try {
				const { data } = await getReviewDistributionCounts()
				commit('SET_COUNTS', data.data)
				commit('SET_COUNTS_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_COUNTS_STATUS', 'init')
				throw error
			}
		},
		async updateSteamStatus(_, { id, status }) {
			const { data } = await updateSteamStatus(id, status)
			return data
		},
		async bulkMarkSteamPosted(_, ids) {
			const { data } = await bulkMarkSteamPosted(ids)
			return data
		},
		async bulkUpdateSteamStatus(_, { ids, status }) {
			const { data } = await bulkUpdateSteamStatus(ids, status)
			return data
		},
		async retryOpenCritic(_, id) {
			const { data } = await retryOpenCritic(id)
			return data
		},
		async updateMetacriticStatus(_, { id, status, note }) {
			const { data } = await updateMetacriticStatus(id, status, note)
			return data
		},
	},
}
